'use client'

import { useEffect } from 'react'
import { Button } from '@/components/ui/button'

export default function CountryError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('Country route error:', error)
  }, [error])

  const isBackendError = error.message.includes('fetch failed') ||
                         error.message.includes('Error setting up the request') ||
                         error.message.includes('Connect Timeout Error')

  if (isBackendError) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ui-bg-subtle px-4">
        <div className="max-w-lg w-full bg-card rounded-lg shadow-lg p-8 border border-ui-border-base">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-warning/10 mb-4">
              <svg
                className="w-8 h-8 text-warning"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
            </div>

            <h1 className="text-2xl font-semibold text-ui-fg-base mb-2">
              Backend Unavailable
            </h1>
            <p className="text-ui-fg-subtle mb-6">
              The Medusa backend is currently unreachable. Please make sure it's running.
            </p>

            {process.env.NODE_ENV === 'development' && (
              <div className="bg-info/10 border border-info/20 rounded-lg p-4 mb-6 text-left">
                <p className="text-sm text-info font-medium mb-2">
                  💡 Development Mode:
                </p>
                <code className="text-xs text-info block">
                  cd src/shop/admin && npm run dev
                </code>
              </div>
            )}

            <div className="flex gap-3">
              <Button onClick={() => reset()} className="flex-1">
                Try Again
              </Button>
              <Button
                variant="secondary"
                onClick={() => window.location.reload()}
                className="flex-1"
              >
                Reload
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-ui-bg-subtle px-4">
      <div className="max-w-lg w-full bg-card rounded-lg shadow-lg p-8 border border-ui-border-base text-center">
        <h1 className="text-2xl font-semibold text-ui-fg-base mb-2">
          Oops! Something went wrong
        </h1>
        <p className="text-ui-fg-subtle mb-6">{error.message}</p>
        <Button onClick={() => reset()}>Try Again</Button>
      </div>
    </div>
  )
}
